import styled from "styled-components";

export default styled.div`
  padding: 12px 12px 0;
  display: flex;
  justify-content: flex-end;
`;
